<script>
import Component from '~/sites/soh/pages/login'
export default {
  extends: Component,
  nuxtI18n: {
    paths: {
      cs: '/prihlasit',
      en: '/login',
      sk: '/prihlasit',
    },
  },
}
</script>
